module.exports = __webpack_public_path__ + "static/img/artist-stef@2x.ac23799.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artist/artist-stef@2x.png
// module id = bfWY
// module chunks = 12